import { render, staticRenderFns } from "./Options.vue?vue&type=template&id=6c53babc&scoped=true&"
import script from "./Options.vue?vue&type=script&lang=js&"
export * from "./Options.vue?vue&type=script&lang=js&"
import style0 from "./Options.vue?vue&type=style&index=0&id=6c53babc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c53babc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VContainer,VMain,VTab,VTabItem,VTabs,VTabsItems})
